import { render } from "./OngoingCaseList.vue?vue&type=template&id=3f81b103&scoped=true"
import script from "./OngoingCaseList.vue?vue&type=script&lang=js"
export * from "./OngoingCaseList.vue?vue&type=script&lang=js"

import "./OngoingCaseList.vue?vue&type=style&index=0&id=3f81b103&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f81b103"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
